import { DTOCustomFieldOption } from 'generated-common';

export interface OptionSearchMatchMarker {
  searchKey: string;
  isCurrent: boolean;
}
export interface OptionSearchData {
  searchKey: string;
  maxFound: number;
  currentOfMaxFound: number;
  currentOptionId: string;
  currentOptionIndex: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface OptionSearchDataChange {
  searchKey?: string;
  direction: 'NEXT' | 'PREVIOUS' | 'UNCHANGED';
}

export const filterOptionsBySearchKey = (options: DTOCustomFieldOption[], currentSearch: OptionSearchData, change: OptionSearchDataChange): OptionSearchData => {
  const searchKeySafe = change && change.searchKey ? change.searchKey : currentSearch.searchKey;
  let currentOfMaxFoundSafe: number = currentSearch.currentOfMaxFound;

  const foundOptionsAndIndizes = options
    .map((o, index) => ({ index: index, option: o }))
    .filter((optionAndIndex) => {
      const value = optionAndIndex && optionAndIndex.option && optionAndIndex.option.value ? optionAndIndex.option.value : '';
      if (searchKeySafe !== '' && value.toLowerCase().search(escapeRegExp(searchKeySafe.toLowerCase())) !== -1) {
        return true;
      } else {
        return false;
      }
    });

  if (change && change.direction === 'UNCHANGED' && foundOptionsAndIndizes && foundOptionsAndIndizes.length > 0) {
    currentOfMaxFoundSafe = 1;
  } else if (change && change.direction === 'NEXT') {
    currentOfMaxFoundSafe = currentSearch.currentOfMaxFound + 1;
  } else if (change && change.direction === 'PREVIOUS') {
    currentOfMaxFoundSafe = currentSearch.currentOfMaxFound - 1;
  } else {
    currentOfMaxFoundSafe = 0;
  }
  const foundOptionIdSafe =
    foundOptionsAndIndizes &&
    foundOptionsAndIndizes[currentOfMaxFoundSafe - 1] &&
    foundOptionsAndIndizes[currentOfMaxFoundSafe - 1].option &&
    foundOptionsAndIndizes[currentOfMaxFoundSafe - 1].option.id
      ? foundOptionsAndIndizes[currentOfMaxFoundSafe - 1].option.id!
      : '0';
  // isNan has ie11 support!
  const foundOptionIndexSafe =
    foundOptionsAndIndizes && foundOptionsAndIndizes[currentOfMaxFoundSafe - 1] && !isNaN(foundOptionsAndIndizes[currentOfMaxFoundSafe - 1].index)
      ? foundOptionsAndIndizes[currentOfMaxFoundSafe - 1].index
      : -1;
  return {
    searchKey: searchKeySafe,
    maxFound: foundOptionsAndIndizes.length,
    currentOfMaxFound: currentOfMaxFoundSafe,
    currentOptionId: foundOptionIdSafe,
    currentOptionIndex: foundOptionIndexSafe,
    hasNext: currentOfMaxFoundSafe + 1 <= foundOptionsAndIndizes.length,
    hasPrevious: currentOfMaxFoundSafe - 1 > 0,
  };
};

export interface HighlightedParts {
  prefix: string | null;
  infix: string | null;
  postfix: string | null;
}

// Escape stuff we put in new RegExp(xx, 'i');
export const escapeRegExp = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& meint den komplett erkannten String
};
export const transformToHighligtedParts = (value: string | null, searchKey: string): HighlightedParts => {
  if (value && searchKey && searchKey.length > 0) {
    const regex = new RegExp(escapeRegExp(searchKey), 'i');
    if (regex.test(value)) {
      const index = value.toLocaleLowerCase().indexOf(searchKey.toLocaleLowerCase());
      const postfix = value.substr(index + searchKey.length);
      return {
        prefix: index === 0 ? null : value.substr(0, index),
        infix: value.substr(index, searchKey.length),
        postfix: postfix !== '' ? postfix : null,
      };
    } else {
      return {
        prefix: value,
        infix: null,
        postfix: null,
      };
    }
  } else {
    return {
      prefix: value,
      infix: null,
      postfix: null,
    };
  }
};
